const DeleteIcon = () => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <g clipPath="url(#clip0_930_8403)">
          <path
            d="M32.5 40H7.5C3.3575 40 0 36.6425 0 32.5V7.5C0 3.3575 3.3575 0 7.5 0H32.5C36.6425 0 40 3.3575 40 7.5V32.5C40 36.6425 36.6425 40 32.5 40Z"
            fill="#FFF1F0"
          />
          <path
            d="M12.5 17.5V27.7087C12.5 28.975 13.525 30 14.7913 30H25.2075C26.475 30 27.5 28.975 27.5 27.7087V17.5H12.5ZM17.5 25.8337C17.5 26.2925 17.125 26.6675 16.6663 26.6675C16.2075 26.6675 15.8325 26.2925 15.8325 25.8337V20.8337C15.8325 20.375 16.2075 20 16.6663 20C17.125 20 17.5 20.375 17.5 20.8337V25.8337ZM20.8337 25.8337C20.8337 26.2925 20.4588 26.6675 20 26.6675C19.5412 26.6675 19.1663 26.2925 19.1663 25.8337V20.8337C19.1663 20.375 19.5412 20 20 20C20.4588 20 20.8337 20.375 20.8337 20.8337V25.8337ZM24.1663 25.8337C24.1663 26.2925 23.7913 26.6675 23.3325 26.6675C22.8738 26.6675 22.4988 26.2925 22.4988 25.8337V20.8337C22.5 20.375 22.875 20 23.3337 20C23.7925 20 24.1675 20.375 24.1675 20.8337L24.1663 25.8337ZM17.5 11.6663H22.5V12.5H24.1663V11.6663C24.1663 10.75 23.4163 10 22.5 10H17.5C16.5838 10 15.8337 10.75 15.8337 11.6663V12.5H17.5V11.6663Z"
            fill="#E62D38"
          />
          <path
            d="M29.1662 14.7913V16.875C29.1662 17.2162 28.8825 17.5 28.5412 17.5H11.4587C11.1175 17.5 10.8337 17.2162 10.8337 16.875V14.7913C10.8337 13.525 11.8587 12.5 13.125 12.5H26.875C28.1412 12.5 29.1662 13.525 29.1662 14.7913Z"
            fill="#FF8585"
          />
        </g>
        <defs>
          <clipPath id="clip0_930_8403">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
  );
};
export default DeleteIcon;
